import moment from "moment"
import MarkerIcon from "./MarkerIcon"
import { IDevicePosition } from "./devices.interface"
import { t } from "i18next"

export const openDeviceInfoWindow = (infoWindow: any, map: any, marker: any, device: any) => {
  if (!infoWindow || !map || !marker) return

  infoWindow.setContent(
    `<strong>${device?.label}</strong><br>${moment(device?.currentPosition?.timestamp).format(
      "YYYY-MM-DD HH:mm"
    )} <br> ${t("map.speed", "Speed")}: ${device?.speed} ${t("map.km_h", "km/h")}`
  )
  infoWindow.open(map, marker)
}

const DeviceMarker = (
  device: IDevicePosition,
  map: any,
  onMarkerClick: any,
  infoWindow: any,
  activeMarker?: any
) => {
  const marker = new google.maps.Marker({
    position: { lat: device.currentPosition.lat, lng: device.currentPosition.long },
    map,
    visible: true,
    title: device.label,
    zIndex: 100
  })
  marker.set("deviceId", device.id)
  MarkerIcon(marker, 0, device)

  marker.addListener("click", () => {
    onMarkerClick(device)
    MarkerIcon(marker, 0, device, activeMarker)
    openDeviceInfoWindow(infoWindow, map, marker, device)
    var latLng = marker.getPosition()
    map.setCenter(latLng)
  })

  return marker
}
export default DeviceMarker
